import api from "./axios";

export interface CompanyCommissionSupplier {
  id: number;
  name: string;
  normalizedName: string;
  active: boolean;
  createdAt: string;
}

export type CompanyCommissionStatus = "pending" | "consolidated" | "voided";

export interface CompanyCommission {
  id: number;
  invoiceId: number;
  invoiceLineId: number;
  ticketDetailId: number;
  supplierId: number;
  supplierNameSnapshot: string;
  priceHt: string;
  commissionPct: string;
  amount: string;
  status: CompanyCommissionStatus;
  activatedAt: string;
  consolidatedBatchId?: number;
  consolidatedAt?: string;
  voidedAt?: string;
  voidedReason?: string;
  createdAt: string;
  invoiceNumber?: string;
  passengerName?: string;
}

export interface CompanyCommissionBatch {
  id: number;
  consolidatedBy: number;
  consolidatedAt: string;
  totalAmount: string;
  count: number;
  note?: string;
  createdAt: string;
  supplierNames: string[];
}

export interface CompanyCommissionStats {
  pendingCount: number;
  pendingAmount: string;
  consolidatedThisMonthCount: number;
  consolidatedThisMonthAmount: string;
  activeSupplierCount: number;
  totalSupplierCount: number;
}

export interface UpdateCompanyCommissionInput {
  supplierName?: string;
  priceHt?: number;
  commissionPct?: number;
}

export interface CompanyCommissionSupplierTotal {
  supplierId: number;
  supplierName: string;
  pendingCount: number;
  pendingAmount: string;
  consolidatedAmount: string;
  lastCommissionAt?: string;
}

export const companyCommissionApi = {
  listSuppliers: (search?: string) =>
    api.get<CompanyCommissionSupplier[]>("/company-commissions/suppliers", {
      params: search ? { search } : undefined,
    }),
  createSupplier: (name: string) =>
    api.post<CompanyCommissionSupplier>("/company-commissions/suppliers", { name }),

  list: (params?: { status?: CompanyCommissionStatus; supplierId?: number }) =>
    api.get<CompanyCommission[]>("/company-commissions", { params }),
  update: (id: number, patch: UpdateCompanyCommissionInput) =>
    api.patch<CompanyCommission>(`/company-commissions/${id}`, patch),
  consolidate: (commissionIds: number[], note?: string) =>
    api.post<CompanyCommissionBatch>("/company-commissions/consolidate", { commissionIds, note }),
  listBatches: () => api.get<CompanyCommissionBatch[]>("/company-commissions/batches"),
  stats: () => api.get<CompanyCommissionStats>("/company-commissions/stats"),
  supplierTotals: () =>
    api.get<CompanyCommissionSupplierTotal[]>("/company-commissions/supplier-totals"),
};
